import { generateKeyBetween } from "fractional-indexing";

/**
 * Ranks are fractional-index strings. Sorting siblings by rank (byte order) gives their order,
 * and placing an item between two others needs only its own rank to change.
 */
export function rankBetween(before: string | null | undefined, after: string | null | undefined): string {
  return generateKeyBetween(before ?? null, after ?? null);
}

export function compareRank(a: { rank: string }, b: { rank: string }): number {
  return a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : 0;
}
